export default __webpack_public_path__ + "static/media/show_middle_frame.34223605.svg";